import styled from 'styled-components';

const Left = styled.div`
  width: auto;
  line-height: 20px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textPrimary};
  align-self: center;
`;

export default Left;
